function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M20.4652 14.0037H9.50991C9.39761 14.0037 9.3103 14.0872 9.3103 14.1946V15.9606C9.3103 16.068 9.39761 16.1515 9.50991 16.1515H13.6649V21.5332C13.6649 21.6406 13.7523 21.7241 13.8646 21.7241H16.1355C16.2478 21.7241 16.3351 21.6406 16.3351 21.5332V16.1515H20.49C20.6023 16.1515 20.6896 16.068 20.6896 15.9606V14.1946C20.6648 14.0872 20.5775 14.0037 20.4652 14.0037ZM14.9875 11.4978C15.9234 11.4978 16.672 10.7698 16.672 9.88685C16.672 8.9918 15.9109 8.27586 14.9875 8.27586C14.0517 8.27586 13.3031 9.00375 13.3031 9.88685C13.3022 10.0986 13.3451 10.3085 13.4295 10.5043C13.5138 10.7002 13.6378 10.8781 13.7944 11.0279C13.951 11.1776 14.137 11.2963 14.3418 11.3769C14.5466 11.4576 14.766 11.4987 14.9875 11.4978Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.9999 26.7271C21.4768 26.7271 26.7271 21.4768 26.7271 14.9999C26.7271 8.52324 21.4768 3.2727 14.9999 3.2727C8.52324 3.2727 3.2727 8.52324 3.2727 14.9999C3.2727 21.4768 8.52324 26.7271 14.9999 26.7271ZM14.9999 30C23.2843 30 30 23.2843 30 14.9999C30 6.71571 23.2843 0 14.9999 0C6.71571 0 0 6.71571 0 14.9999C0 23.2843 6.71571 30 14.9999 30Z",
  fill: "white"
});

var SvgIconTbtc = function SvgIconTbtc(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconTbtc, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-tbtc.9d193512.svg";
export { ForwardRef as ReactComponent };